import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import 'swiper/swiper-bundle.min.css'
import http from 'src/helper/http'
import ReminderBtn from 'src/component/RuleButton'
import Message from 'src/component/Message'

import {  chooseImage, uploadFile } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.ruby = this.props.store.register('app/ruby')
  }

  state = {
    lang: langM.ar,
    language: 'en',
    userInfo: {},
    uploadpic:[],
    ipormac: null,
    timemyselect: null,
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    console.log('admin-control-user', this.props.location.query)
    this.setState({
      uid: uid,
      fidUid:this.props.location.query.finduid*1,
      
    })

    if (this.state.language == 'tr') {
      setDocumentTitle('Yönetici Kontrol Paneli')
    } else if (this.state.language == 'en') {
      setDocumentTitle('Admin control panel')
    } else if (this.state.language == 'ar') {
      setDocumentTitle('لوحة تحكم المشرف ')
    }
    await this.getUserInfo(this.props.location.query.finduid)
  }

  showModle = (open, close) => {
    let { lang } = this.state
    return (
      <div
        className="gold-modle"
        onClick={() => {
          close()
        }}
      >
        <div className="gold-modletitle">{lang.banText}</div>
        <div className="gold-modle-body">


        </div>
        <div className="gold-modle-btn">
          <div
            className="modle-cancle"
            onClick={() => {
              close()
            }}
          >
            {lang.no}
          </div>
          <div
            className="modle-confirm"
            onClick={() => this.resetRoomInfo()}
          >
            {lang.yes}
          </div>
        </div>
      </div>
    )
  }
  // 初始化/接口请求初始化
  resetRoomInfo = async()=>{
    let { setValue,  lang, fidUid , uploadpic, uid  } = this.state
    if (uid == fidUid)  return  this.refs.msg.show(lang.nohad)
    let res = await http.post('/web/user/reset',{uid:fidUid,reason:setValue,pic:uploadpic[0]})
    if (res.code == 0) {
      this.refs.msg.show(lang.successful)
    }else if (res.code == 9999 ) {
      this.refs.msg.show(lang.nohad)
    } 
    
  }
  getUserInfo = async (uid) => {
    let res = await http.post('/web/user/info', { uidDuid: uid + '' })
    if (res.code == 0) {
      this.setState({ userInfo: res.res })
    }
  }

  clearImg = () => {
    this.setState({
      uploadpic:[],
    })
  }

  setRamekValue = (e)=>{
    this.setState({setValue: e.target.value})
  }
  render() {
    let { lang, userInfo  } = this.state
    return (
      <div className="bane-reset-new">
        <div className="user-card-new">
          <div className="set-user-info-new">
            <div className="avatar-root-new">
              <img className="avatar-img-new" src={userInfo.avatarurl}></img>
            </div>
            <div className="user-info-new">
              <div className="user-info-top-new">
                <div className="top-text-new">{userInfo.nickname}</div>
              </div>
              <div className="user-info-top-new">
                <div className="top-text-new">{userInfo.bio}</div>
              </div>
              <div className="user-info-buttom-new">ID: {userInfo.uid}</div>
            </div>
          </div>
        </div>
       <div className="text-title-new">{lang.reset}</div>

         <ReminderBtn
          lang={this.state.lang}
          slotButtonComp={() => {
            return <div className="ban-reset-new">{lang.resetPersonalData}</div>
          }}
          slotContentComp={this.showModle}
        />



        <Message ref="msg" desc={this.state.desc} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/admin-control/newBaneReset/index.js